import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";

export default function PortalVerify() {
  const navigate = useNavigate();
  const [message, setMessage] = useState("Bezig met inloggen…");

  useEffect(() => {
    const token = new URLSearchParams(window.location.search).get("token");
    window.history.replaceState({}, "", "/portaal");
    if (!token) { setMessage("Ongeldige of verlopen link."); return; }
    api.post("/portal/verify", { token })
      .then(() => navigate("/portaal/overzicht", { replace: true }))
      .catch((e) => setMessage(e?.response?.data?.detail || "Deze link is ongeldig, verlopen of al gebruikt."));
    // eslint-disable-next-line
  }, []);

  return (
    <div className="min-h-screen bg-[#F7F5EF] flex items-center justify-center px-4">
      <div className="text-slate-500 text-center" data-testid="portal-verify-status">{message}</div>
    </div>
  );
}
